import { useAgentChatResearchGeneration } from './useAgentChatResearchGeneration';
import { createRecommendationTrackingWrapper } from './createRecommendationTrackingWrapper';
import { MessageDisplay } from '../../types/chat-hook-types';
import { supabase } from '@/integrations/supabase/client';

/**
 * Research generation with recommendation tracking
 * Auto-generated using the standardized factory pattern
 * Now supports both temporary and database IDs for reliability
 */
export const useAgentChatResearchGenerationWithTracking = (message: MessageDisplay | string) => {
  console.log('[useAgentChatResearchGenerationWithTracking] 🚀 Hook called with message:', typeof message === 'string' ? message : { id: message.id, databaseId: message.databaseId });
  
  console.log('[useAgentChatResearchGenerationWithTracking] 🔍 Creating tracking wrapper...');
  
  // Apply tracking wrapper
  const trackingWrapper = createRecommendationTrackingWrapper(
    useAgentChatResearchGeneration,
    'research',
    {
      // Simplified metadata for private research tracking (no project dependencies)
      getMetadata: (params, result) => {
        console.log('[ResearchTracking] Starting metadata generation for private research:', params);
        
        const metadata = {
          researchTitle: params.research?.title || 'Private Research',
          researchDescription: params.research?.description || ''
          // No goalId or projectId - private research
        };
        
        console.log('[ResearchTracking] Final metadata:', metadata);
        return metadata;
      },
      // Use the generated research ID from the result
      getSavedItemId: (result) => result.generatedResearch?.id // Use generatedResearch.id from result
    }
  );
  
  console.log('[useAgentChatResearchGenerationWithTracking] ✅ Tracking wrapper created');
  
  const result = trackingWrapper(message);
  
  console.log('[useAgentChatResearchGenerationWithTracking] 🔍 Wrapper result:', {
    hasFunction: !!result.mutateWithTracking,
    functionType: typeof result.mutateWithTracking
  });
  
  return result;
}; 